import { CdkTrapFocus } from '@angular/cdk/a11y'
import { Component, input, output, ViewChild, ViewEncapsulation } from '@angular/core'
import { Uuid } from '@ftr/contracts/type/shared'
import {
  ButtonComponent,
  IconComponent,
  MenuComponent,
  MenuItemButton,
  selectWith,
  TooltipModule,
} from '@ftr/foundation'
import {
  AddFavoriteInCourtSystemAction,
  CurrentFavoriteService,
  FavoritesState,
  SetFavoritesEditModalVisible,
} from '@ftr/ui-user'
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap'
import { Store } from '@ngxs/store'
import { take } from 'rxjs'
import { SideNavDisplayMode, SideNavItem } from '../../../navigation'

@Component({
  selector: 'ftr-favorites-menu',
  templateUrl: './favorites-menu.component.html',
  styleUrls: ['./favorites-menu.component.css'],
  encapsulation: ViewEncapsulation.None,
  imports: [TooltipModule, IconComponent, NgbPopover, MenuComponent, CdkTrapFocus, ButtonComponent],
})
export class FavoritesMenuComponent {
  displayMode = input.required<SideNavDisplayMode>()
  collapsed = input.required<boolean>()
  courtSystemId = input.required<Uuid>()
  dropDownOpened = output<SideNavItem[]>()

  protected menuItems: MenuItemButton[] = [
    { label: 'Favorite this page', action: this.addFavoriteAction.bind(this) },
    { label: 'Edit favorites', action: this.openEditModal.bind(this) },
  ]

  @ViewChild('popover') popover: NgbPopover

  constructor(
    private readonly store: Store,
    private readonly currentFavoriteService: CurrentFavoriteService,
  ) {}

  protected readonly favorites = selectWith(() => FavoritesState.favorites(this.courtSystemId()))

  protected addFavoriteAction(): void {
    this.currentFavoriteService
      .currentFavoriteData()
      .pipe(take(1))
      .subscribe(({ courtSystemId, url, label }) => {
        return this.store.dispatch(new AddFavoriteInCourtSystemAction(courtSystemId!, url, label))
      })
  }

  protected openEditModal(): void {
    this.popover.close()
    this.store.dispatch(new SetFavoritesEditModalVisible(true))
  }

  protected menuSideNavItems(): SideNavItem[] {
    return this.menuItems.map(menuItem => {
      return {
        type: 'BUTTON',
        title: menuItem.label,
        onSelect: menuItem.action,
      }
    })
  }
}
